import doc                      from '@widesk-core/decorators/doc';
import NetworkServiceModel      from '@/models/NetworkServiceModel';

@doc.path('/contact_groups/{?id}')
export default class ContactGroupModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.string declare reference: string;
}